import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import AppBootScreen from '../components/pwa/AppBootScreen';
import { isStandaloneDisplay } from '../components/pwa/PwaInstallContext';

function loginPathFor(location) {
  const nextPath = `${location.pathname}${location.search || ''}`;
  return `/login?next=${encodeURIComponent(nextPath)}`;
}

export default function ProtectedRoute({ children }) {
  const { user, authLoading, actingAsChild } = useAuth();
  const location = useLocation();

  if (authLoading) {
    if (isStandaloneDisplay()) return <AppBootScreen />;
    return (
      <div className="page">
        <section className="section">
          <p className="text-muted">Loading...</p>
        </section>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={loginPathFor(location)} replace />;
  }

  if (user.email && user.emailVerified === false && !actingAsChild) {
    const nextPath = `${location.pathname}${location.search || ''}`;
    return <Navigate to={`/verify-email?next=${encodeURIComponent(nextPath)}`} replace />;
  }

  return children;
}
